module.exports = __webpack_public_path__ + "poster1.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster1.png
// module id = 1131
// module chunks = 10